<template>
  <div>
    <div class="innerBox">
      <div class="innerTitle">
        <el-button type="primary" size="small" @click="openDia">新增</el-button>
        <div class="screenBox">
          <el-select v-model="contractorInfoId" placeholder="请选择所属单位" size="small" @change="selectChange" style="width: 30%" clearable>
            <el-option label="本企业" :value="0" />
            <el-option label="外来车辆" :value="-1" />
            <el-option v-for="item in contractorList" :key="item.id" :value="item.id" :label="item.contrName" />
          </el-select>
          <el-select v-model="type" size="small" style="width: 30%" placeholder="请选择进出场" @change="selectChange" clearable>
            <el-option label="进场" :value="0" />
            <el-option label="出场" :value="1" />
          </el-select>
          <Input search enter-button placeholder="请输入姓名/车牌号" style="width: 35%" v-model="licensePlate"
            @on-search="searchInp" />
        </div>
      </div>
      <el-table
        :data="tableData"
        border
        :header-cell-style="{ background: 'rgb(232,232,232)', height: '55px', textAlign: 'center' }"
        :row-style="{ height: '55px' }"
        :cell-style="{ textAlign: 'center' }"
        style="width: 100%">
        <el-table-column
          type="index"
          :index='(index) => {return index + 1 + (curPage-1)*limit}'
          label="序号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="licensePlate"
          label="车牌号">
        </el-table-column>
        <el-table-column
          prop="contrName"
          label="所属单位">
        </el-table-column>
        <el-table-column
          label="驾驶员" >
          <template slot-scope="scope">{{ scope.row.aname||scope.row.bname }}</template>
        </el-table-column>
        <el-table-column
          label="联系电话">
          <template slot-scope="scope">{{ scope.row.aphone||scope.row.bphone }}</template>
        </el-table-column>
        <el-table-column
          label="进/出场">
          <template slot-scope="{ row }">
            <span v-if="row.inOut === 0" style="color: #67C23A">进场</span>
            <span v-if="row.inOut === 1" style="color: #E6A23C">出场</span>
          </template>
        </el-table-column>
         <el-table-column
          prop="enterTime"
          label="进场时间">
        </el-table-column>
        <el-table-column
          prop="time"
          label="出场时间">
          <template slot-scope="{ row }">
            {{ row.inOut === 0 ? '' : row.time }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="{ row }">
            <el-link type="primary" v-if="row.inOut === 0" style="margin-right: 10px" @click="out(row)">出场</el-link>
            <el-link type="danger" @click="deleteList(row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 15px; text-align: right">
        <Page :total='total' :page-size='limit' :current='curPage' @on-change='curPageChange' />
      </div>
    </div>
    <!-- 新增/编辑的弹窗 -->
    <div class="formBox">
      <el-dialog title="车辆信息" :visible.sync="dialogFormVisible" width="23%" @close="closeDia">
        <el-form :model="form" :rules="rules" ref="form">
          <el-form-item label="车牌号" :label-width="formLabelWidth" prop="licensePlate">
            <el-input v-model="form.licensePlate" auto-complete="off" size="small" style="width: 76%" />
          </el-form-item>
          <el-form-item label="进出场" :label-width="formLabelWidth" prop="in_out">
            <el-select v-model="form.in_out" placeholder="进出场" style="width: 76%" size="small">
              <el-option label="进场" :value="0" />
              <el-option label="出场" :value="1" />
            </el-select>
          </el-form-item>
          <el-form-item label="驾驶员" :label-width="formLabelWidth" prop="driver">
            <el-input v-model="form.vehicle_name" auto-complete="off" size="small" style="width: 76%" />
          </el-form-item>
          <el-form-item label="时间" :label-width="formLabelWidth" prop="gmtCreate">
            <el-date-picker v-model="form.gmtCreate" type="datetime" placeholder="选择日期时间" size="small"
              value-format="yyyy-MM-dd HH:mm:ss" style="width: 76%" />
          </el-form-item>
          <el-form-item label="联系电话" :label-width="formLabelWidth" prop="phone">
            <el-input v-model="form.vehicle_phone" auto-complete="off" size="small" style="width: 76%" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="margin:auto">
          <el-button @click="closeDia" size="small">取 消</el-button>
          <el-button type="primary" @click="sureBtn('form')" size="small">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { vehicleInOutList, getStaffList, addvehicleRecord, vehicleOut, deleteVehicleRecord } from '@/api/processManager'
import { getDepartmentList } from '@/api/wholeProcess'
export default {
  name: 'peopleInOut',
  data() {
    return {
      tableData: [],
      total: 0,
      limit: 10,
      curPage: 1,
      contractorInfoId: '',
      type: '',
      licensePlate: '',
      contractorList: [],
      form: {},
      dialogFormVisible: false,
      formLabelWidth: '100px',
      personList: [],
      rules: {
        in_out: [
          { required: true, message: '请选择进出场', trigger: 'change' }
        ],
        licensePlate: [
          { required: true, message: '请输入车牌号', trigger: 'change' }
        ],
        gmtCreate: [
          { required: true, message: '请选择时间', trigger: 'change' }
        ],
      },
    }
  },
  created() {
    this.getData();
    this.getContractorList();
  },
  methods: {
    // 获取表格数据
    getData() {
      vehicleInOutList({
          limit: this.limit,
          curPage: this.curPage,
          contractorInfoId: this.contractorInfoId,
          type: this.type,
          licensePlate: this.licensePlate
        }).then(res => {
        this.tableData = res.body.data;
        this.total = res.body.cum
      })
    },
    // 获取承包商列表（下拉框用）
    getContractorList() {
      getDepartmentList({ limit: 100, curPage: 1 }).then(res => {
        this.contractorList = res.body.data;
      })
    },
    curPageChange(val) {
      this.curPage = val;
      this.getData();
    },
    selectChange() {
      this.getData();
    },
    searchInp() {
      this.getData()
    },
    // 弹窗的一些事件
    openDia() {
      this.dialogFormVisible = true;
    },
    closeDia() {
      this.$refs['form'].resetFields()
      this.dialogFormVisible = false
      this.form = {}
      // this.form = {...this.form2}
      // this.isEdit = false
    },
    // 根据承包商和本企业查询人员
    diaSelect(val) {
      this.personList = [];
      if(this.form.type === 0){
        getStaffList({ contractorId: 0 }).then(res => {
          this.personList = res.body.data;
        })
      }
    },
    diaSelect1(val) {
      getStaffList({ contractorId: val }).then(res => {
        this.personList = res.body.data;
      })
    },
    // 弹窗表单的确认按钮
    sureBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addvehicleRecord({ ...this.form }).then(res => {
            this.$message.success('添加成功');
            this.closeDia();
            this.getData();
          })
        } else {
          return false;
        }
      });
    },
    // 出场
    out(row) {
      vehicleOut({ id: row.id }).then(res => {
        this.$message.success('操作成功');
        this.getData();
      })
    },
    deleteList(row) {
      deleteVehicleRecord(row.id).then(res => {
        this.$message.success('删除成功');
        this.getData();
      })
    }
  }
}
</script>

<style scoped>
.myHead {
  position: absolute;
  top: 0px;
  left: 250px;
  width: 80%;
  height: 60px;
}
.innerBox {
  width: 100%;
  height: 100%;
  background-color: white;
  padding: 10px
}
.innerTitle {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}
.innerTitle .screenBox {
  width: 45%;
  display: flex;
  justify-content: space-between;
}
.formBox /deep/ .el-form-item {
  margin-bottom: 10px
}
.formBox /deep/ .el-form-item__error {
  padding-top: 2px
}
</style>
